import { z } from 'zod';
import { RelationshipAssetSchema } from '../IRelationshipAsset';
import { legalTransactionRelationshipDocumentSchema } from './ILegalTransactionRelationshipDocument';
import { partnerIdentifierSchema } from './IPartnerIdentifier';
import { legalTransactionRelationshipRealEstateSchema } from './Relationships/RealEstate/ILegalTransactionRelationshipRealEstate';

export function GenericLegalTransactionRelationshipSchema<
  TType extends z.ZodTypeAny,
  TVersion extends z.ZodOptional<z.ZodTypeAny>,
  TData extends z.ZodTypeAny,
  TMember extends z.ZodTypeAny,
>(idRelationshipType: TType, Version: TVersion, data: TData, member: TMember) {
  return z.object({
    idRelationshipType,
    Version,
    data,
    Members: z.array(member),
    idRelationship: z.number(),
    RelationshipType: z.string(),
    /** Only set for main relationship */
    idLegalTransaction: z.number(),
    Parent_idRelationship: z.number().optional(),
    isActiveRelationship: z.boolean(),
    companyFormationLegalTransaction: z.string().nullable().optional(),
    isCompanyFormation: z.boolean(),
    syncWithArnoTop: z.boolean(),
    Created: z.date(),
    Updated: z.date(),
    DocumentArray: z.array(legalTransactionRelationshipDocumentSchema),
    RealEstateArray: z.array(legalTransactionRelationshipRealEstateSchema),
    PartnerIdentifiers: z.array(partnerIdentifierSchema),
    AssetArray: z.array(RelationshipAssetSchema),
  });
}
